import React from 'react';
import { FieldSelectWithReduxProps } from './types';
import { FieldSelect } from '.';

export const FieldSelectWithRedux = ({
  input: { name, value, onChange },
  meta: { error },
  placeholderText,
  ...html
}: FieldSelectWithReduxProps) => (
  <FieldSelect
    {...html}
    name={name}
    value={value}
    error={error ? { message: error } : undefined}
    placeholder={placeholderText}
    onChange={onChange}
  />
);
